// Os ambientes Fictor de produção e homologação usam o perfil ALVOCARD.
export const isFictor = ['FICTOR', 'ALVOCARD'].includes(
  (process.env.REACT_APP_PERFIL || '').trim().toUpperCase()
);
